import { ADD_FIELD_VALIDATION_ERROR, REMOVE_FIELD_VALIDATION_ERROR, SHIFT_FIELD_VALIDATION_ERROR } from 'ContentData/actions/ActionTypes';
export const addValidationError = fieldKey => dispatch => dispatch({
  type: ADD_FIELD_VALIDATION_ERROR,
  fieldKey
});
export const removeValidationError = fieldKey => dispatch => dispatch({
  type: REMOVE_FIELD_VALIDATION_ERROR,
  fieldKey
});
export const shiftValidationError = (fieldKey, fromIndex, toIndex) => {
  return dispatch => dispatch({
    type: SHIFT_FIELD_VALIDATION_ERROR,
    fieldKey,
    fromIndex,
    toIndex
  });
};